require('./morningstarStyleBox.scss');

const PropTypes = require('prop-types');

const React= require('react');

// @ helpers
const { formatText } = require('core/i18n').i18n;

const PADDING = 40;
const LABELS_MARGIN = 10;

class MorningstarStyleBox extends React.Component {

    getX(d, squareWidth) {
        let x;
        if (d === 1 || d === 4 || d === 7) {
            x = 0;
        } else if (d === 2 || d === 5 || d === 8) {
            x = squareWidth;
        } else {
            x = squareWidth * 2;
        }
        return x + PADDING;
    }

    getY(d, squareHeight) {
        let y;
        if (d < 4) {
            y = 0;
        } else if (d < 7) {
            y = squareHeight;
        } else {
            y = squareHeight * 2;
        }
        return y + PADDING;
    }

    render() {
        const {width, height, activeSquare} = this.props;
        const totalWidth = (PADDING * 2) + parseInt(width, 10);
        const totalHeight = (PADDING * 2) + parseInt(height, 10);
        const squareWidth = width / 3;
        const squareHeight = height / 3;
        /**
         * La caja es fija, la distribución es:
            123
            456
            789
         */
        const squaresArray = [1,2,3,4,5,6,7,8,9];

        const squares = squaresArray.map(item => {
            return (
                <rect
                    key={`square-${item}`}
                    width={squareWidth}
                    height={squareHeight}
                    x={this.getX(item, squareWidth)}
                    y={this.getY(item, squareHeight)}
                    className={item === activeSquare ? 'morningstar-style-box__square--active' : 'morningstar-style-box__square'}
                />
            );
        });

        return (
            <div className="morningstar-style-box">
                <svg width={totalWidth}
                    height={totalHeight}
                    shapeRendering="geometricPrecision"
                >
                    <g className="morningstar-style-box__container">
                        <rect className="morningstar-style-box__square"
                            width={width}
                            height={height}
                            x={PADDING}
                            y={PADDING}
                        >
                        </rect>
                        {squares}
                    </g>
                    <text textAnchor="middle" transform="rotate(-90)" className="morningstar-style-box__label-text--title"
                        x={-(totalHeight / 2)}
                        y={(PADDING/2) + LABELS_MARGIN}
                    >
                        {formatText('broker-morningstarStyleBoxTextSize')}
                    </text>
                    <text textAnchor="middle" className="morningstar-style-box__label-text--title"
                        x={totalWidth / 2}
                        y={(PADDING/2) + LABELS_MARGIN}
                    >
                        {formatText('broker-morningstarStyleBoxTextStyle')}
                    </text>
                    <text textAnchor="middle" transform="rotate(90)" className="morningstar-style-box__label-text"
                        x={((squareHeight / 2) + PADDING)}
                        y={-((totalWidth - PADDING) + LABELS_MARGIN)}
                    >
                        {formatText('broker-morningstarStyleBoxTextSmall')}
                    </text>
                    <text textAnchor="middle" transform="rotate(90)" className="morningstar-style-box__label-text"
                        x={((squareHeight / 2) + PADDING + squareWidth)}
                        y={-((totalWidth - PADDING) + LABELS_MARGIN)}
                    >
                        {formatText('broker-morningstarStyleBoxTextMedium')}
                    </text>
                    <text textAnchor="middle" transform="rotate(90)" className="morningstar-style-box__label-text"
                        x={((squareHeight / 2) + PADDING + (squareWidth * 2))}
                        y={-((totalWidth - PADDING) + LABELS_MARGIN)}
                    >
                        {formatText('broker-morningstarStyleBoxTextBig')}
                    </text>
                    <text textAnchor="middle" className="morningstar-style-box__label-text"
                        x={(squareWidth/2) + PADDING}
                        y={totalHeight - PADDING/2}
                    >
                        {formatText('broker-morningstarStyleBoxTextValue')}
                    </text>
                    <text textAnchor="middle" className="morningstar-style-box__label-text"
                        x={(squareWidth/2) + PADDING + squareWidth}
                        y={totalHeight - PADDING/2}
                    >
                        {formatText('broker-morningstarStyleBoxTextMixt')}
                    </text>
                    <text textAnchor="middle" className="morningstar-style-box__label-text"
                        x={(squareWidth/2) + PADDING + (squareWidth * 2)}
                        y={totalHeight - PADDING/2}
                    >
                        {formatText('broker-morningstarStyleBoxTextGrow')}
                    </text>
                </svg>
            </div>
        );
    }
}

MorningstarStyleBox.propTypes = {
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    activeSquare: PropTypes.number.isRequired
};

module.exports = MorningstarStyleBox;